 
<template>
  <div class="projectmanage">
    <TagsCloud ref="cloudtage" @cloudTages="cloudTages" />
    <div class="crudblock">
      <avue-crud
        :option="option"
        :data="data"
        ref="crud"
        :page.sync="page"
        :search.sync="query"
        v-model="form"
        @on-load="onLoad"
        @search-change="searchChange"
        @search-reset="searchReset"
        @sort-change="sortChange"
      >
        <template slot="menuLeft">
          <el-button
            size="small"
            type="primary"
            icon="el-icon-plus"
            v-if="permission.zg_edit"
            @click="handleAdd()"
          >
            新建项目</el-button
          >
          <el-button
            size="small"
            plain
            @click="exportShow"
            v-if="permission.zg_export"
            icon="el-icon-download"
            >导出数据</el-button
          >
          <el-button
            size="small"
            plain
            @click="showUpload"
            v-if="permission.zg_upload"
            icon="el-icon-upload2"
            >
            导入模版
            </el-button>          
        </template>

        <template slot-scope="scope" slot="menu">
          <el-button
            type="success"
            size="small"
            icon="el-icon-arrow-right"
            plain
            @click.stop="handleDetail(scope.row)"
            >详情
          </el-button>
          <el-button
            type="primary"
            plain
            size="small"
            icon="el-icon-edit"
            v-if="permission.zg_edit && userInfo.user_id == scope.row.managerUser"
            @click.stop="handleEdit(scope.row, scope.index)"
            >编辑
          </el-button>
          <el-button
            type="danger"
            plain
            size="small"
            icon="el-icon-delete-solid"
            v-if="userInfo.user_id == scope.row.managerUser"
            @click.stop="handleDel(scope.row.id)"
            >删除
          </el-button>
        </template>
        <template slot="searchMenu" slot-scope="{ row }">
          <el-button type="primary" @click="save(row)">保存</el-button>
        </template>
        <template slot="menuRight">
          <el-tooltip class="item" effect="dark" content="显隐" placement="top">
            <el-button
              icon="el-icon-s-operation"
              circle
              @click="operation"
            ></el-button>
          </el-tooltip>
        </template>
      </avue-crud>
    </div>
      <!-- uploadUrl="/api/zg/zgproject/import-master"
      openUrl="/api/zg/zgproject/export-template" -->
    <uploadForm
      :uploadUrl="uploadUrl"
      :openUrl="openUrl"
      uploadTitle="资金项目管理数据导入"
      @refreshData='refreshList'
      ref="uploadDialog" />
    
    <ExportData ref="exportData" @exportDownload="exportDownload" />
    <SelectPerson
      ref="selectperson"
      :checkUserList="checkUserList"
      :clear="true"
      @setPeople="setPeople"
    />
    <Options
      ref="Options"
      :plainOptions="optionColumn"
      :pageDataId="this.$route.path"
      @returnData="returnData"
    />
    <Adddialog
      ref="adddialog"
      :goType="goType"
      @addDialogFinish="dialogFinish"
    />
  </div>
</template>

<script>
import * as api from "@/api/zg/projectmanage";
import * as dictionaries from "@/api/zd/dictionaries";

import { mapGetters } from "vuex";
import { downLoadTemplate } from "@/router/downLoadTem";
import TagsCloud from "@/components/TagsCloud/TagsCloud";
import SelectPerson from "@/components/SelectPersonnel/person";
import ExportData from "@/components/exportData/exportData";
import uploadForm from "@/components/uploadForm/uploadForm";
import Options from "@/components/ShowHidden/showhidden";
import { examConfig } from "./config";
import Adddialog from "./adddialog";
export default {
  name: "zgprojectList",
  data() {
    let self = this;
    return {
      uploadUrl: '',
      openUrl: '',
      optionColumn: examConfig(self.selectPersonClick).column,
      shlb: 0,
      form: {},
      managerUserIds: "",
      page: {
        currentPage: 1,
        total: 0,
        layout: "total,pager,prev, next",
        background: false,
        pageSize: 10,
      },
      goType: 1,
      query: {},
      data: [],
      option: examConfig(self.selectPersonClick),
      checkUserList: [],
    };
  },
  computed: {
    ...mapGetters(["permission", "userInfo"]),
  },
  watch: {},

  components: {
    uploadForm,
    TagsCloud,
    SelectPerson,
    Options,
    ExportData,
    Adddialog,
  },
  created() {},
  activated() {
    this.onLoad(this.page);
  },
  methods: {
    refreshList(){
      this.onLoad(this.page)
    },
    showUpload() {
      this.goType = 3
      this.$refs.adddialog.showblock()      
      // this.$refs.uploadDialog.showModel()
    },

    dialogFinish(projectType) {
      if(this.goType == 2){
        // 导出数据
        this.query.projectType = projectType
        this.exportDownload({code: 2})
      } else {
        this.openUrl = `/api/zg/zgproject/export-template?type=${projectType}`
        this.uploadUrl = `/api/zg/zgproject/import-data?type=${projectType}`
        // 导入入数据
        this.$refs.uploadDialog.showModel()
      }
    },
    //显隐
    operation() {
      this.$refs.Options.showmode();
    },
    //显隐回调
    returnData(data) {
      this.option.column = data;
    },
    onLoad(page) {
      api
        .getList({
          firstNum: (page.currentPage - 1) * page.pageSize,
          num: page.pageSize,
          ...this.query,
        })
        .then((res) => {
          //   this.auditlistNub = res.data.data.shlb;
          this.page.total = res.data.data.total;
          this.data = res.data.data.records;
          console.log(res);
        })
        .catch((res) => {
          console.log(res);
        });
    },
    handleAdd() {
      this.goType = 1
      this.$refs.adddialog.showblock();
    },
    //排序
    sortChange(val) {
      this.query.orderValue =
        val.order == "descending"
          ? "desc"
          : val.order == "ascending"
          ? "asc"
          : "";

      this.query.orderName = val.prop;
      this.page.currentPage = 1;
      this.onLoad(this.page);
    },
    //搜索
    searchChange(params, done) {
      this.query = params;
      this.page.currentPage = 1;
      this.onLoad(this.page);
      done();
    },
    searchReset() {
      if (this.cloudStatus) {
        this.cloudStatus = false;
        return;
      }
      this.query = {
        managerUserIds: '',
        managerUserNames: '',
        projectType: '',
        search: ''
      };
      this.checkUserList = [];
      this.onLoad(this.page);
    },
    save(row) {
      this.$refs.cloudtage.save(row);
    },

    //常用查询
    cloudTages(data) {
      this.cloudStatus = true;
      this.$refs.crud.searchReset();
      this.form = data;
      this.searchChange(data);
    },
    handleEdit(row) { 
      this.$router.push({ path: `/zg/assetManageEdit/${row.id}` }); 
    },
    handleDetail(row) {
      this.$router.push({ path: `/zg/detail/${row.id}` });
    },
       handleDel(id) {
     this.$confirm("确定将选择数据删除?", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          return api.remove({ ids: id });
        })
        .then(() => {
          this.onLoad(this.page);
          this.$message({
            type: "success",
            message: "操作成功!",
          });
          this.$refs.crud.toggleSelection();
        });
    },
    //获取 人员名称
    getVisitPeople() {
      let people = this.checkUserList.map((item) => {
        return item.realName;
      });
      let ids = this.checkUserList.map((item) => {
        return item.id;
      });
      this.$nextTick(() => {
        this.form.managerUserNames = people.join(",");
        this.form.managerUserIds = ids.join(",");
        this.managerUserIds = ids.join(",");
        this.query.managerUserNames = people.join(",");
        this.query.managerUserIds = ids.join(",");
      });
      console.log(this.managerUserIds);
    },
    // 人员选择插件打开
    selectPersonClick() {
      let value = this.managerUserIds;
      let list = value ? value.split(",") : [];
      if (list.length > 0) {
        this.infoByIds(list);
      } else {
        this.checkUserList = [];
        this.$refs.selectperson.showmode();
      }
    },
    infoByIds(ids) {
      dictionaries
        .infoByIds({
          ids: ids,
        })
        .then((res) => {
          this.checkUserList = res.data.data;
          this.$refs.selectperson.showmode();
        })
        .catch((res) => {
          console.log(res);
        });
    },
    //人员 获取
    setPeople(val) {
      this.checkUserList = val;
      this.getVisitPeople();
    },

    exportShow() {
      this.goType = 2
      this.$refs.adddialog.showblock()
      // this.$refs.exportData.showModel();
    },
    exportDownload(value) {
      let page = this.page;
      let data = {
        export: value.code,
      };
      if (value.code == 1) {
        data = {
          ...data,
          firstNum: (page.currentPage - 1) * page.pageSize,
          num: page.pageSize,
          ...this.query,
        };
      } else if (value.code == 2) {
        data = {
          ...data,
          ...this.query,
        };
      }
      downLoadTemplate("/api/zg/zgproject/export", data).finally(() => {
        this.loading = false;
        this.$message({
          type: "success",
          message: "已下载",
        });
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.projectmanage {
  .topcrud {
    line-height: 45px;
    font-size: 18px;
    background: #f9f9f9;
    border-radius: 15px 15px 0 0;
    text-indent: 25px;
    // margin: 0 5px;
    border-bottom: 1px solid #e9e9e9;
    .messagetitle {
      font-weight: bolder;
    }
  }
  .crudblock {
    background: #ffff;
    padding: 25px;
  }
}
.none-border {
  border: 0;
  background-color: transparent !important;
}
</style>
